module.exports = __webpack_public_path__ + "img/intro_game.9292450c.png";